import log from "loglevel";
import * as React from "react";
import { AiFillPushpin } from "react-icons/ai";
import { AiOutlinePushpin } from "react-icons/ai";
// import * as constants from "Constants";
import httpService from 'services/httpService.js';
import { store } from "Store";
import { RiArrowDropDownLine, RiArrowDropRightLine, RiDeleteBin7Line } from "react-icons/ri";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import AccordionContext from "react-bootstrap/AccordionContext";
import { Container, Row, Col, Accordion, Card, Spinner } from "react-bootstrap";
import { useContext } from "react";
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import ReactHtmlParser from 'react-html-parser';
// import moment from "moment";
import CustomCKEditor, { resetCkEditorInstanceData } from "Components/CustomCKEditor";
import { FiEdit3 } from "react-icons/fi";

function formatDateTime(isoString) {
    const date = new Date(isoString);

    const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false, // 24-hour format
    };

    return new Intl.DateTimeFormat("en-US", options).format(date);
}

const AnnouncementCkEditorInstanceName = "Announcement";

function ContextAwareToggle({ children, eventKey, callback }) {
    const currentEventKey = useContext(AccordionContext);

    const _decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(eventKey)
    );

    const isCurrentEventKey = currentEventKey === eventKey;

    if (isCurrentEventKey) {
        return (
            <Row>
                <Col sm={11}>{children}</Col>
                <Col sm={1}>
                    <RiArrowDropDownLine
                        size={35}
                        color="grey"
                        style={{ margin: "-10 0 -10 10" }}
                    />
                </Col>
            </Row>
        );
    } else {
        return (
            <Row>
                <Col sm={11}>{children}</Col>
                <Col sm={1}>
                    <RiArrowDropRightLine
                        size={35}
                        color="grey"
                        style={{ margin: "-10 0 -10 10" }}
                    />
                </Col>
            </Row>
        );
    }
}


export default class CourseAnnouncements extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            announcements: [],
            announcementInput: "",
            searchInputText: "",
            startDate: "",
            endDate: "",
            editing: new Set(),
            announcement_notification: false,
            announcement_checkbox: false,
            loaded: false,
            publishingAnnouncement: false,

        };
    }


    getUser = () => {
        const state = store.getState();
        return state.userInfo;
    };


    announcementnotification = async () => {
        let url = '/courseware/api/courseinfo/' + this.props.courseId + '/?format=json';

        try {
            const res = await httpService.get(url);
            const data = res.data;

            this.setState({
                announcement_notification: res.announcement_notification
            });
            log.log(res, " Announcement Notification");
        } catch (error) {
            log.error(error);
        }
    }


    fetchAnnouncements = async () => {
        let url = "/announcements/api/announcement/" + this.props.courseId + "/get_all_announcements/?format=json";

        try {
            const res = await httpService.get(url);
            const data = res.data;

            if (data.isEmpty) {
                this.setState({ announcements: [] });
            } else {
                data.all.forEach((announcement) => {
                    announcement.editedText = announcement.description;
                });
                this.setState({ announcements: data.all });
            }
            this.setState({ loaded: true });

            // log.log(data ,'Data',res)
        } catch (error) {
            log.error(error);
        }
    }

    componentDidMount() {
        this.fetchAnnouncements();
        this.announcementnotification();

    }

    handleErrorsAndExtractJson(response) {
        if (!response.statusText === 'OK') {
            throw Error(response.statusText);
        }
        return () => response.json();
    }

    handlePin = async (id, pinned) => {
        const user = this.getUser();

        let url = `/announcements/api/announcement/${id}/pinUnpin_announcement/?format=json`;

        try {
            await httpService.instance({
                method: "patch",
                url: url,
                headers: {
                    Authorization: `Token ${user.token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            this.fetchAnnouncements();
            if (!pinned)
                displayGlobalMessage("Announcement pinned", "success");
            else
                displayGlobalMessage("Announcement un-pinned", "success");
        } catch (error) {
            log.log(error);
        }
    };

    handleDelete = async (id) => {
        const user = this.getUser();

        const confirmation = confirm(
            "Are you sure you want to delete the announcement?"
        );
        if (!confirmation) {
            return;
        }
        let url = `/announcements/api/announcement/${id}/delete_announcement/?format=json`;

        try {
            await httpService.instance({
                method: "delete",
                url: url,
                headers: {
                    Authorization: `Token ${user.token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            this.fetchAnnouncements();
            displayGlobalMessage("Announcement Successfully deleted", "success");
        } catch (error) {
            //log.log(error);
        }
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        try {
            this.setState({ publishingAnnouncement: true });

            const user = this.getUser();

            log.log(user.token, "User TOken")

            if (!this.state.announcementInput) {
                displayGlobalMessage("Announcement Cannot be empty", "error");
                return;
            }
            const url = "/announcements/api/announcement/" + this.props.courseId + "/create_announcement/?format=json";
            let fd = new FormData();
            fd.append("description", this.state.announcementInput);
            fd.append("announcement_notification", this.state.announcement_checkbox);

            try {
                await httpService.instance({
                    method: "post",
                    url: url,
                    data: fd,
                    headers: {
                        Authorization: `Token ${user.token}`,
                        "Content-Type": "multipart/form-data",
                    },
                });
                resetCkEditorInstanceData(AnnouncementCkEditorInstanceName);
                this.fetchAnnouncements();
                this.setState({
                    announcementInput: ""
                });
                this.setState({
                    announcementInput: '',
                    announcement_checkbox: false
                });
                displayGlobalMessage("Announcement Added Successfully", "success");
            } catch (error) {
                log.error(error);
                log.error(error?.response?.data)
                displayGlobalMessage("Failed to create the announcement", "error");
            }
        } catch (err) {
            // pass
        } finally {
            this.setState({ publishingAnnouncement: false })
        }
    };

    handleUpdate = async (id, editedText) => {
        const user = this.getUser();
        const url = "/announcements/api/announcement/" + `${id}` + "/edit_announcement/?format=json";

        let fd = new FormData();
        fd.append("description", editedText);
        fd.append("csrfmiddlewaretoken", `${user.token}`);

        try {
            await httpService.instance({
                method: "patch",
                url: url,
                data: fd,
                headers: {
                    Authorization: `Token ${user.token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            this.fetchAnnouncements();
            const temp = this.state.editing;
            temp.delete(id);
            this.setState({ editing: temp });
            displayGlobalMessage("Announcement updated", "success");
        } catch (error) {
            log.error(error);
        }
    };


    toggleEdit = (id) => {
        if (this.state.editing.has(id)) {
            const newSet = this.state.editing;
            newSet.delete(id);
            this.setState({ editing: newSet });
        } else {
            this.setState({ editing: this.state.editing.add(id) });
        }
    };

    render() {
        return (
            <Container className="border padding p-3">
                <div className="container">
                    <Row className="d-flex align-items-center">
                        <Col md={{ span: 8, offset: 0 }}>
                            <h4 style={{ color: '#007BFF' }}>
                                Course Announcements
                            </h4>
                        </Col>
                    </Row>
                    <hr
                        style={{
                            marginLeft: 5,
                            marginRight: 5,
                            height: '1px',
                            border: 'none',
                            backgroundColor: 'grey'
                        }}
                    />

                    <div className="mb-4">
                        <Accordion>
                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                    <ContextAwareToggle eventKey="0">
                                        Make an announcement
                                    </ContextAwareToggle>
                                </Accordion.Toggle>

                                <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        <form>
                                            <div className="form-group">
                                                <label>Announcement</label>
                                                <CustomCKEditor
                                                    name={AnnouncementCkEditorInstanceName}
                                                    placeholder="Enter announcement"
                                                    value={this.state.announcementInput}
                                                    onChange={(data) => {
                                                        this.setState({
                                                            announcementInput: data.html || data.text,
                                                        });
                                                    }}
                                                />
                                            </div>
                                            {this.state.announcement_notification == false ?
                                                <div>
                                                    <input type="checkbox" checked={this.state.announcement_checkbox} onChange={(event) => { this.setState({ announcement_checkbox: event.target.checked }) }} />
                                                    &nbsp;&nbsp;
                                                    Send email for this announcement
                                                </div>
                                                : <div></div>
                                            }


                                            <button
                                                className="btn btn-primary"
                                                onClick={this.handleSubmit}
                                                disabled={this.state.publishingAnnouncement}
                                            >
                                                {this.state.publishingAnnouncement && <Spinner animation="border" size="sm" className="mr-2" />}
                                                <span>Publish</span>
                                            </button>
                                        </form>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </div>


                    <div className="mb-4">
                        <Accordion>
                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                    <ContextAwareToggle eventKey="0">
                                        Search
                                    </ContextAwareToggle>
                                </Accordion.Toggle>

                                <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        <div className="form-group">
                                            <input
                                                className="form-control"
                                                placeholder="Enter search item..."
                                                value={this.state.searchInputText}
                                                onChange={(e) =>
                                                    this.setState({
                                                        searchInputText: e.target.value,
                                                    })
                                                }
                                            ></input>
                                        </div>
                                        <div className="row" style={{ display: "flex", alignItems: "flex-end" }}>
                                            <div className="col-xs-12 col-md-4">
                                                <label htmlFor="sdate">Start Date</label>
                                                <input
                                                    className="form-control"
                                                    id="sdate"
                                                    name="sdate"
                                                    type="date"
                                                    value={this.state.startDate}
                                                    onChange={(e) => this.setState({ startDate: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-md-4">
                                                <label htmlFor="edate">End Date</label>
                                                <input
                                                    className="form-control"
                                                    id="edate"
                                                    name="edate"
                                                    type="date"
                                                    value={this.state.endDate}
                                                    onChange={(e) => this.setState({ endDate: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-md-4">
                                                <button className="btn btn-primary" onClick={() => {
                                                    this.setState({ endDate: "", startDate: "", searchInputText: "" })
                                                }}>
                                                    Clear
                                                </button>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </div>

                    <div className="mb-4">
                        {this.state.loaded ? (this.state.announcements
                            .filter((announcement) =>
                                announcement.description
                                    .toLowerCase()
                                    .includes(
                                        this.state.searchInputText
                                            .toLowerCase()
                                            .trim()
                                    )
                                && (!this.state.startDate || new Date(announcement.publish_date) >= new Date(this.state.startDate))
                                && (!this.state.endDate || new Date(announcement.publish_date) <= new Date(this.state.endDate))
                            )
                            .sort((a, b) => (a.pinned ? -1 : 1))
                            .map((announcement) =>
                                !this.state.editing.has(announcement.id) ? (
                                    <div
                                        className="card card-body mb-2"
                                        style={{ position: "relative" }}
                                    >
                                        {formatDateTime(announcement.publish_date)}:{" "}
                                        <div
                                            className="d-flex"
                                            style={{
                                                position: "absolute",
                                                top: 5,
                                                right: 10,
                                            }}
                                        >
                                            <button
                                                className="btn btn-sm"
                                                onClick={() =>
                                                    this.toggleEdit(announcement.id)
                                                }
                                            >
                                                <FiEdit3 size={18} />
                                            </button>
                                            <button
                                                className="btn btn-sm"
                                                onClick={() =>
                                                    this.handleDelete(
                                                        announcement.id
                                                    )
                                                }
                                            >
                                                <RiDeleteBin7Line size={18} color="#FF5E61" />
                                            </button>
                                            <button
                                                className="btn btn-sm"
                                                onClick={() =>
                                                    this.handlePin(announcement.id, announcement.pinned)
                                                }
                                            >
                                                {announcement.pinned
                                                    ? <AiFillPushpin size={18} />
                                                    : <AiOutlinePushpin size={18} />}
                                            </button>
                                        </div>
                                        {ReactHtmlParser(announcement.description)}
                                    </div>
                                ) : (
                                    <div className="form-group">
                                        <label>Edit announcement</label>
                                        <CustomCKEditor
                                            name={`AnnouncementEdit-${announcement.id}`}
                                            placeholder="Enter announcement"
                                            value={announcement.editedText}
                                            onChange={(data) => {
                                                announcement.editedText = data.text
                                                this.setState({
                                                    announcements: this.state.announcements,
                                                });
                                            }}
                                        />
                                        <button
                                            className="btn btn-primary mr-2 mt-2"
                                            onClick={() =>
                                                this.handleUpdate(announcement.id, announcement.editedText)
                                            }
                                        >
                                            Update
                                        </button>
                                        <button
                                            className="btn btn-danger mt-2"
                                            onClick={() =>
                                                this.toggleEdit(announcement.id)
                                            }
                                        >
                                            Close
                                        </button>
                                    </div>
                                )
                            )) :
                            <div className="text-center" style={{ marginTop: '2vh', transform: 'translateY(-50%)' }}>
                                <Spinner animation="border" role="status" />
                            </div>
                        }
                    </div>
                </div>
            </Container>

        );
    }

}
